const name = "cliente-dropdown-item";
export default {
  name,

  components: {},

  props: {
    dadosCliente: {
      type: Object,
      default: {
        razaoSocial: '',
        codigo: '',
        nomeFantasia: '',
        situacao: '',
        estadoCidade: '',
        cnpj: '',
      },
    },
  },

  mounted() {},

  updated() {},

  data() {
    return {
      textoClienteSituacao: ['A', 'D', 'I']
    };
  },

  methods: {
    aplicaMascaraCnpj(cnpjSemMascara){
      if(!cnpjSemMascara) return cnpjSemMascara
      return cnpjSemMascara.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,"$1.$2.$3/$4-$5")
    }
  },

  computed: {},
};
